export function obfuscateEmail(email = "") {
  const [name, domain] = email.split("@");
  if (!name || !domain) return email;
  const obfuscatedName = name.slice(0, 4) + "*".repeat(name.length - 4);
  return `${obfuscatedName}@${domain}`;
}
